package org.lennycodes.hldi.backend.db_service

import kotlinx.coroutines.await
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.deleteDoc
import org.lennycodes.hldi.backend.doc

suspend fun deleteMilestone(id: String) {

    val milestonesCollection = collection(
        FirebaseService.db,
        "milestones"
    )

    val milestoneDocument = doc(
        milestonesCollection,
        id
    )

    deleteDoc(milestoneDocument).await()

}
